import React, { useState } from 'react';
import { Card } from './ui/card';
import { Button } from './ui/button';
import { Users, Maximize, Euro, Images } from 'lucide-react';
import { spaces } from '../data/mock';
import ImageGallery from './ImageGallery';

const Spaces = () => {
  const [galleryOpen, setGalleryOpen] = useState(false);
  const [selectedSpace, setSelectedSpace] = useState(null);

  const handleReservation = (spaceName) => {
    // Mock action - scroll to contact form
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const openGallery = (space) => {
    setSelectedSpace(space);
    setGalleryOpen(true);
  };

  return (
    <section id="espaces" className="py-16 md:py-24 bg-gradient-to-b from-[#F8F8F5] to-[#F8F8F5]">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-3xl md:text-5xl font-bold text-[#4A6B96] mb-6">
            Nos espaces de bureaux et salles de réunion
          </h2>
          <p className="text-base md:text-xl text-gray-600">
            Du bureau privatif à la salle de réunion, en passant par notre manoir pour séminaires : découvrez nos espaces professionnels à Versailles, Jouy-en-Josas et Viroflay, pensés pour tous vos besoins.
          </p>
        </div>

        {/* Spaces Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {spaces.map((space, index) =>
          <Card
            key={space.id}
            className="group overflow-hidden border-0 shadow-lg hover:shadow-2xl transition-all duration-500 bg-[#FEFEFE] flex flex-col h-full"
            style={{ animationDelay: `${index * 100}ms` }}>

              {/* Image */}
              <div
              className="relative h-80 overflow-hidden cursor-pointer"
              onClick={() => openGallery(space)}>

                <img
                src={space.image}
                alt={space.title}
                className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                style={{ objectPosition: 'center 30%' }} />

                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
                
                {/* Type Badge */}
                <div className="absolute top-4 left-4 bg-[#FFFFFF] text-[#4A6B96] px-4 py-2 rounded-full font-semibold text-sm">
                  {space.type}
                </div>

                {/* Gallery indicator */}
                <div className="absolute top-4 right-4 bg-[#FEFEFE] text-[#4A6B96] px-3 py-2 rounded-full font-semibold text-sm flex items-center gap-2">
                  <Images size={16} />
                  {space.gallery.length}
                </div>

                {/* Hover overlay */}
                <div className="absolute inset-0 bg-black/50 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
                  <div className="text-white text-center">
                    <Images size={48} className="mx-auto mb-2" />
                    <p className="font-semibold">Voir la galerie</p>
                  </div>
                </div>
              </div>

              {/* Content */}
              <div className="p-8 flex flex-col flex-grow">
                <h3 className="text-2xl font-bold text-[#4A6B96] mb-3">
                  {space.title}
                </h3>
                
                <p className="text-gray-600 mb-6 leading-relaxed">
                  {space.description}
                </p>

                {/* Details */}
                <div className="flex flex-col gap-3 mb-6 mt-auto">
                  <div className="flex items-center space-x-2 text-sm text-gray-700">
                    <Users size={18} className="text-[#4A6B96]" />
                    <span>{space.capacity}</span>
                  </div>
                  <div className="flex items-center space-x-2 text-sm text-gray-700">
                    <Maximize size={18} className="text-[#4A6B96]" />
                    <span>{space.surface}</span>
                  </div>
                  <div className="flex items-center space-x-2 text-sm font-semibold text-[#4A6B96]">
                    <Euro size={18} />
                    <span>{space.price}</span>
                  </div>
                </div>

                {/* CTA Button */}
                <Button
                onClick={() => handleReservation(space.title)}
                className="w-full bg-[#4A6B96] hover:bg-[#4A6B96]/90 text-white font-semibold">

                  Réserver une Visite
                </Button>
              </div>
            </Card>
          )}
        </div>

        {/* Bottom CTA */}
        <div className="mt-16 text-center">
          <div className="inline-block p-8 rounded-2xl bg-[#4A6B96]/5 border-2 border-[#FFFFFF]">
            <p className="text-lg text-gray-700 mb-4">
              Besoin d'un espace personnalisé ou d'un conseil ?
            </p>
            <Button
              onClick={() => handleReservation('Contact')}
              className="bg-[#FFFFFF] hover:bg-[#E5E7EB] text-[#4A6B96] font-semibold px-8">

              Parlons de votre Projet
            </Button>
          </div>
        </div>
      </div>

      {/* Image Gallery Modal */}
      {selectedSpace &&
      <ImageGallery
        images={selectedSpace.gallery}
        isOpen={galleryOpen}
        onClose={() => setGalleryOpen(false)}
        title={selectedSpace.title} />

      }
    </section>);

};

export default Spaces;